import LocalImages from "assets/images/local-images";
import Content, { ContentNS } from "content/content";
import Body from "features/shared/styles/typography/Body.styled";
import { FC, useEffect, useRef } from "react";

import CanvasLabel from "./styles/CanvasLabel.styled";
import PreviewDisclaimer from "./styles/PreviewDisclaimer.styled";
import ResultImagesContainer from "./styles/ResultImagesContainer.styled";
import ScannedFrame from "./styles/ScannedFrame.styled";
import ScanResultPreview from "./styles/ScanResultPreview.styled";

interface ScanningResultsPreviewProps {
  images: ImageData[];
}

const ScanningResultsPreview: FC<ScanningResultsPreviewProps> = ({
  images,
}) => {
  const textUI = (s: string) => Content.shared.t(s, { ns: ContentNS.ui });
  const canvasHasLabel = images.length > 1;

  const previewRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (previewRef.current) {
      previewRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  return (
    <ScanResultPreview>
      <PreviewDisclaimer ref={previewRef}>
        <img
          alt="preview success icon"
          src={LocalImages.shared.images.icons.successPrimary2}
        />
        <Body>{textUI("scanning-preview")}</Body>
      </PreviewDisclaimer>
      <ResultImagesContainer>
        {images.map((image, index) => {
          return (
            <ScannedFrame key={index}>
              <CanvasLabel visible={canvasHasLabel}>
                <Body>{`${textUI("scan-result-canvas-label")} ${
                  index + 1
                }`}</Body>
              </CanvasLabel>
              <canvas
                id={`working-canvas-${index}`}
                // className="invisible"
                width={image.width}
                height={image.height}
              />
              <canvas
                id={`result-canvas-${index}`}
                className="invisible"
                width={image.width}
                height={image.height}
              />
            </ScannedFrame>
          );
        })}
      </ResultImagesContainer>
    </ScanResultPreview>
  );
};

export default ScanningResultsPreview;
